/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import {
	CreateDeal,
	addProductInDeal,
	deleteDealProducts,
	getCurrentDealProducts,
	getDealListing,
	getDealProductList,
	getNextDealProducts,
	updateDeal,
	updateDealProductData,
	updateDealProductSequence
} from '../apis/dealsApIs';
import { t } from 'i18next';
import { showSuccess } from '../../app/utils/sweetAlert';
import { showSuccessToast } from '../../app/utils/tostify';
interface initialStateInterFace {
	error: any;
	loading: boolean;
	listingLoading: boolean;
	dealsList: Array<any>;
	dealProductList: Array<any>;
	currentPage: number;
	listingCurrentPage: number;
	count: number;
	listingCount: number;
	currentDealProductCount: number;
	currentDealPage: number;
	selectedList: any;
	dealDetails: any;
	searchKey: string;
	page: number;
	currentDealProduct: Array<any>;
}
const initialState: initialStateInterFace = {
	error: '',
	loading: false,
	listingLoading: false,
	dealsList: [],
	dealProductList: [],
	currentPage: 1,
	listingCurrentPage: 1,
	count: 0,
	listingCount: 0,
	currentDealProductCount: 0,
	page: 0,
	currentDealPage: 1,
	selectedList: [],
	dealDetails: null,
	searchKey: '',
	currentDealProduct: []
};
const dealsSlice = createSlice({
	name: 'dealsSlice',
	initialState,
	reducers: {
		updateCurrentPage(state, action) {
			state.currentPage = action.payload;
		},
		handleSearchKey(state, action) {
			state.searchKey = action.payload;
		},
		updateDealsPage(state, action) {
			state.page = action.payload;
		},
		updateSelectedList(state, action) {
			state.selectedList = action.payload;
		},
		updateCurrentDealPage(state, action) {
			state.currentDealPage = action.payload;
		},
		decrementTotalCount(state, action) {
			state.currentDealProductCount =
				state.currentDealProductCount - action.payload;
		},
		updateDealsProductList(state) {
			state.dealProductList = [];
		},
		updateListingCurrentPage(state, action) {
			state.currentPage = action.payload;
		},
		updateCurrentDealList(state, action) {
			state.currentDealProduct = action.payload;
		},
		updateCurrentDealProductCount(state) {
			state.currentDealProductCount = 0;
		},
		resetCurrentDealState(state) {
			state.currentDealProduct = [];
			state.currentDealProductCount = 0;
			state.selectedList = [];
			state.currentDealPage = 1;
		}
	},
	extraReducers: builder => {
		builder.addCase(CreateDeal.pending, (state: initialStateInterFace) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			CreateDeal.fulfilled,
			(state: initialStateInterFace, action: any) => {
				(state.loading = false), (state.error = '');
			}
		);
		builder.addCase(CreateDeal.rejected, (state: initialStateInterFace) => {
			state.loading = false;
		});
		builder.addCase(updateDeal.pending, (state: initialStateInterFace) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(updateDeal.fulfilled, (state: initialStateInterFace, action) => {
			state.loading = false;
			state.error = '';
			if (action.meta.arg.toaster) {
				showSuccessToast({ message: t(action.payload.message) });
			}
		});
		builder.addCase(updateDeal.rejected, (state: initialStateInterFace) => {
			state.loading = false;
		});
		builder.addCase(getDealProductList.pending, (state: initialStateInterFace) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getDealProductList.fulfilled,
			(state: initialStateInterFace, action) => {
				state.loading = false;
				state.error = '';
				state.dealProductList = action.payload.data?.list;
				state.count = action?.payload?.data?.count;
			}
		);
		builder.addCase(getDealProductList.rejected, (state: initialStateInterFace) => {
			state.loading = false;
		});
		builder.addCase(addProductInDeal.pending, (state: initialStateInterFace) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addProductInDeal.fulfilled,
			(state: initialStateInterFace, action) => {
				state.loading = false;
				state.error = '';
				state.page = 1;
				if (action?.meta?.arg?.lastBatch) {
					showSuccessToast({ message: t(action.payload.message) });
				}
			}
		);
		builder.addCase(addProductInDeal.rejected, (state: initialStateInterFace) => {
			state.loading = false;
		});
		builder.addCase(getDealListing.pending, (state: initialStateInterFace) => {
			state.loading = true;
			state.error = '';
		});

		builder.addCase(
			getDealListing.fulfilled,
			(state: initialStateInterFace, action) => {
				state.loading = false;
				state.error = '';
				state.dealsList = action.payload.data?.list;
				state.listingCount = action?.payload?.data?.count;
			}
		);
		builder.addCase(getDealListing.rejected, (state: initialStateInterFace) => {
			state.loading = false;
		});

		builder.addCase(
			getCurrentDealProducts.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			getCurrentDealProducts.fulfilled,
			(state: initialStateInterFace, action) => {
				state.loading = false;
				state.error = '';
				state.currentDealProduct = [
					...state.currentDealProduct,
					...(action.payload.data?.list || [])
				];
				state.currentDealProduct = state.currentDealProduct.filter(
					(v, i, s) =>
						s.findIndex(v2 => ['_id'].every(k => v2[k] === v[k])) === i
				);
				state.currentDealProductCount = action?.payload?.data?.count;
			}
		);
		builder.addCase(
			getCurrentDealProducts.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			updateDealProductSequence.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			updateDealProductSequence.fulfilled,
			(state: initialStateInterFace, action) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(
			deleteDealProducts.fulfilled,
			(state: initialStateInterFace, action) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(
			updateDealProductSequence.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(updateDealProductData.pending, (state: initialStateInterFace) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			updateDealProductData.fulfilled,
			(state: initialStateInterFace, action) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(
			updateDealProductData.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(getNextDealProducts.fulfilled, (state: initialStateInterFace) => {
			state.loading = false;
		});
		builder.addCase(getNextDealProducts.rejected, (state: initialStateInterFace) => {
			state.loading = false;
		});
		builder.addCase(getNextDealProducts.pending, (state: initialStateInterFace) => {
			state.loading = true;
		});
	}
});
export const {
	updateCurrentPage,
	handleSearchKey,
	updateDealsProductList,
	updateListingCurrentPage,
	updateCurrentDealList,
	updateSelectedList,
	resetCurrentDealState,
	updateCurrentDealPage,
	updateCurrentDealProductCount,
	decrementTotalCount
} = dealsSlice.actions;
export default dealsSlice.reducer;
